// extracted by mini-css-extract-plugin
module.exports = {"calendar-note":"styles_calendar-note__n_0Bz","calendar-note__icon":"styles_calendar-note__icon__3Gnib","calendar-note__text":"styles_calendar-note__text__St4Df"};